import ExecutionsList from "../../components/executionsList/ExecutionsList";
import { useExecutionsQuery } from "../../tanstack/hooks/usePlayerQuery";
import useGetSessionId from "../../hooks/useGetSessionId";
import Loader from "../../components/Loader";
import { useLocation, useNavigate } from "react-router";
import { useCallback, useEffect, useMemo } from "react";
import firePostMessage from "../../utils/firePostMessage";
import { setLastBet } from "../../stores/cardsStore/CardsStore";
import { useWebSocket } from "../../hooks/useWebSocket";
import { YantraExecution } from "../../tanstack/queries/player";

function ExecutionsPage() {
  const sessionId = useGetSessionId();
  const navigate = useNavigate();
  const { search } = useLocation();

  useWebSocket({});

  const { data, isLoading } = useExecutionsQuery(sessionId);

  useEffect(() => {
    if (data?.yantraExecutions.length === 1) {
      const executionId = data.yantraExecutions[0].id;
      setLastBet({ images: {}, rows: {} });
      navigate({ pathname: `/${executionId}`, search });

      firePostMessage({ type: "round_change", id: executionId });
    }
  }, [data, navigate, search]);

  const removeDuplicates = useCallback((arr: YantraExecution[]): YantraExecution[] => {
    const map = new Map<string, YantraExecution>();

    for (const item of arr) {
      const existing = map.get(item.yantraId);

      if (!existing) {
        map.set(item.yantraId, item);
      } else {
        if (existing.status === "CALCULATED" && item.status !== "CALCULATED") {
          map.set(item.yantraId, item);
        }
      }
    }

    return Array.from(map.values());
  }, []);

  const memoizedExecutions = useMemo(() => {
    return removeDuplicates(data?.yantraExecutions || []) || [];
  }, [data?.yantraExecutions]);

  if (isLoading) {
    return <Loader />;
  }

  return <ExecutionsList executions={memoizedExecutions} />;
}

export default ExecutionsPage;
